import { render, staticRenderFns } from "./myProfileHeader.vue?vue&type=template&id=38dc0361&scoped=true"
import script from "./myProfileHeader.vue?vue&type=script&lang=js"
export * from "./myProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./myProfileHeader.vue?vue&type=style&index=0&id=38dc0361&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc0361",
  null
  
)

export default component.exports